import { render, staticRenderFns } from "./HireEmployee.vue?vue&type=template&id=21cee2e6&scoped=true&"
import script from "./HireEmployee.vue?vue&type=script&lang=js&"
export * from "./HireEmployee.vue?vue&type=script&lang=js&"
import style0 from "./HireEmployee.vue?vue&type=style&index=0&id=21cee2e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cee2e6",
  null
  
)

export default component.exports